import { IOnboardingForms, IStep } from '@/model';
import { AgencyDocumentTypeChoices, CompanyDocumentTypeChoices, UserOnboardingStatus } from '@homeserve/od-typings/api';

export enum OnboardingRouteName {
  CATCHMENT_AREA = 'onboarding-catchment-area',
  COMPANY = 'onboarding-company',
  DOCUMENTS = 'onboarding-documents',
  EQUIPMENT = 'onboarding-equipment',
  SKILLS = 'onboarding-skills',
  SUMMARY = 'onboarding-summary',
  USER = 'onboarding-user',
}

export enum AdminRouteName {
  DASHBOARD = 'admin-dashboard',
  COMPANY = 'admin-company',
  AGENCIES = 'admin-agencies',
  PROFILE = 'admin-profile',
}

export enum FormScope {
  CATCHMENT_AREA = 'catchment_area_form',
  COMPANY = 'company_form',
  DOCUMENTS = 'documents_form',
  EQUIPMENT = 'equipment_form',
  SKILLS = 'skills_form',
  USER = 'user_form',
}

export enum StepperComponent {
  CATCHMENT_AREA = 'CatchmentAreaForm',
  COMPANY = 'CompanyForm',
  DOCUMENTS = 'DocumentsForm',
  EQUIPMENT = 'EquipmentForm',
  SKILLS = 'SkillsForm',
  SUMMARY = 'Summary',
  USER = 'UserForm',
}

export const ONBOARDING_FORMS: IOnboardingForms = {
  [FormScope.CATCHMENT_AREA]: {
    departments: [],
    catchmentArea: null,
  },
  [FormScope.COMPANY]: {
    address: null,
    birthCity: '',
    birthCountry: 'France',
    birthDate: null,
    companyName: '',
    creationDate: null,
    holderName: '',
    iban: '',
    isVatApplicable: true,
    legalForm: null,
    personalAddress: null,
    rcsCity: '',
  },
  [FormScope.DOCUMENTS]: {
    [CompanyDocumentTypeChoices.IBAN]: {
      file: null,
    },
    [CompanyDocumentTypeChoices.KBIS]: {
      file: null,
      validityStartDate: null,
    },
    [AgencyDocumentTypeChoices.RESPONSABILITE_CIVILE_PROFESSIONNELLE]: {
      file: null,
      rcpNum: '',
      validityEndDate: null,
      validityStartDate: null,
    },
  },
  [FormScope.EQUIPMENT]: {
    equipment: [],
  },
  [FormScope.SKILLS]: {
    domains: [],
    products: [],
  },
  [FormScope.USER]: {
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    postCode: '',
    password: '',
    registrationNumber: '',
  },
};

export const ONBOARDING_STEPS: IStep[] = [
  {
    component: StepperComponent.USER,
    formScope: FormScope.USER,
    key: UserOnboardingStatus.USER_INFOS,
    label: 'headings.onboarding.user',
    name: OnboardingRouteName.USER,
    valid: false,
  },
  {
    component: StepperComponent.COMPANY,
    formScope: FormScope.COMPANY,
    key: UserOnboardingStatus.COMPANY_INFOS,
    label: 'headings.administrative',
    name: OnboardingRouteName.COMPANY,
    valid: false,
  },
  {
    component: StepperComponent.CATCHMENT_AREA,
    formScope: FormScope.CATCHMENT_AREA,
    key: UserOnboardingStatus.JOB_AREA,
    label: 'headings.onboarding.catchmentArea',
    name: OnboardingRouteName.CATCHMENT_AREA,
    valid: false,
  },
  {
    component: StepperComponent.SKILLS,
    formScope: FormScope.SKILLS,
    key: UserOnboardingStatus.JOB_SKILLS,
    label: 'headings.onboarding.skills',
    name: OnboardingRouteName.SKILLS,
    valid: false,
  },
  {
    component: StepperComponent.EQUIPMENT,
    formScope: FormScope.EQUIPMENT,
    key: UserOnboardingStatus.JOB_EQUIPMENT,
    label: 'headings.onboarding.equipment',
    name: OnboardingRouteName.EQUIPMENT,
    valid: false,
  },
  {
    component: StepperComponent.DOCUMENTS,
    formScope: FormScope.DOCUMENTS,
    key: UserOnboardingStatus.DOCUMENTS_SUBMISSION,
    label: 'headings.documents',
    name: OnboardingRouteName.DOCUMENTS,
    valid: false,
  },
  {
    component: StepperComponent.SUMMARY,
    key: UserOnboardingStatus.DONE,
    label: 'headings.onboarding.summary',
    name: OnboardingRouteName.SUMMARY,
  },
];
